import { render, staticRenderFns } from "./RmOrderDetailsView.vue?vue&type=template&id=7a9084f7&scoped=true&"
import script from "./RmOrderDetailsView.vue?vue&type=script&lang=js&"
export * from "./RmOrderDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./RmOrderDetailsView.vue?vue&type=style&index=0&id=7a9084f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9084f7",
  null
  
)

export default component.exports